<template>
  <div>
    <v-overlay :value="loading" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="error.show">
      <p class="py-0 my-0 font-weight-black">{{ error.title }}</p>
      {{ error.message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

    <v-toolbar flat v-if="!loading" style="background-color: #f3f3f3" class="mb-3">

      <v-spacer />

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="grey" dark class="mb-2 ml-2" v-bind="attrs" v-on="on" @click="atualizar()">
            <v-icon small> mdi-refresh </v-icon>
          </v-btn>
        </template>
        <span>Atualizar dashboard</span>
      </v-tooltip>

    </v-toolbar>

    <v-container class="ma-0" v-if="!loading" fluid>
      <!-- CRITICAS -->
      <v-row>
        <v-col class="ml-2" v-if="dashboard.criticas.length">
          <v-card class="mx-auto">
            <v-card-text>
              <div>
                Críticas e informações importantes para observação e correção
              </div>
              <p class="text-h4 red--text">Críticas</p>
              <div class="text--primary">
                <ul v-for="loja in dashboard.criticas" :key="loja.critica">
                  <li>{{ loja.critica }}</li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="text-xs-center">
        <!-- TOTALIZADOR DE VISITAS -->
        <v-col class="ml-2">
          <v-card class="mx-auto" outlined>
            <v-card-text>
              <div>Visitas nos últimos 30 dias</div>
              <p class="text-h4 text--primary">
                {{ dashboard.totalizadores.visitas | formatNumber }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TOTALIZADOR DE FATURAMENTO -->
        <v-col class="ml-2">
          <v-card class="ml-2 mx-auto" outlined>
            <v-card-text>
              <div>Faturamento nos últimos 30 dias</div>
              <p class="text-h4 text--primary">
                {{
                  dashboard.totalizadores.faturamento.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TOTALIZADOR DE USUARIOS -->
        <v-col class="ml-2">
          <v-card class="ml-5 mx-auto" outlined>
            <v-card-text>
              <div>Total de usuários cadastrados</div>
              <p class="text-h4 text--primary">
                {{ dashboard.totalizadores.usuarios | formatNumber }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TOTALIZADOR DE PEDIDOS -->
        <v-col class="ml-2">
          <v-card class="ml-5 mx-auto" outlined>
            <v-card-text>
              <div>Total de pedidos realizados</div>
              <p class="text-h4 text--primary">
                {{ dashboard.totalizadores.pedidos | formatNumber }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div class="my-5 py-2">
        <h3>Últimos 30 dias</h3>
        <hr />
      </div>

      <v-row>
        <!-- TOP FATURAMENTO -->
        <v-col class="ml-2">
          <v-card class="mx-auto">
            <v-card-text>
              <div>Os clientes que mais faturam</div>
              <p class="text-h4 text--primary">+Faturamento</p>
              <div class="text--primary">
                <ul v-for="loja in dashboard.faturamento.maior" :key="loja.nome">
                  <li>
                    {{
                      parseFloat(loja.analytics.fat30dias).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )
                    }}
                    - {{ loja.nome }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- MENOS FATURAM -->
        <v-col class="ml-2">
          <v-card class="mx-auto">
            <v-card-text>
              <div>Os clientes que menos faturam</div>
              <p class="text-h4 text--primary">-Faturamento</p>
              <div class="text--primary">
                <ul v-for="loja in dashboard.faturamento.menor" :key="loja.nome">
                  <li>
                    {{
                      parseFloat(loja.analytics.fat30dias).toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )
                    }}
                    - {{ loja.nome }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- TOP VENDAS -->
        <v-col class="ml-2">
          <v-card class="mx-auto">
            <v-card-text>
              <div>Os clientes que mais vendem</div>
              <p class="text-h4 text--primary">+Vendas</p>
              <div class="text--primary">
                <ul v-for="loja in dashboard.vendas.maior" :key="loja.nome">
                  <li>
                    {{ loja.analytics.totalPedidos | formatNumber }} vendas -
                    {{ loja.nome }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- MENOS VENDEM -->
        <v-col class="ml-2">
          <v-card class="mx-auto">
            <v-card-text>
              <div>Os clientes que menos vendem</div>
              <p class="text-h4 text--primary">-Vendas</p>
              <div class="text--primary">
                <ul v-for="loja in dashboard.vendas.menor" :key="loja.nome">
                  <li>
                    {{ loja.analytics.totalPedidos | formatNumber }} vendas -
                    {{ loja.nome }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div class="my-5 py-2">
        <h3>Informativos</h3>
        <hr />
      </div>

      <v-row>
        <!-- LOJAS -->
        <v-col class="ml-2">
          <v-card class="w-25">
            <v-card-text>
              <div>
                Informações relevantes dos
                {{ dashboard.lojas.total | formatNumber }} estabelecimentos
                cadastrados
              </div>
              <p class="text-h4 text--primary">Informações</p>
              <div class="text--primary">
                <ul>
                  <li>
                    {{ dashboard.lojas.abertas | formatNumber }}
                    estabelecimentos abertos
                  </li>
                  <li>
                    {{ dashboard.lojas.fechadas | formatNumber }}
                    estabelecimentos fechados
                  </li>
                  <li>
                    {{ dashboard.lojas.atrasados | formatNumber }}
                    estabelecimentos com mensalidades atrasadas
                  </li>
                  <li>
                    {{ dashboard.lojas.demos | formatNumber }}
                    estabelecimentos de demonstração
                  </li>
                  <li>
                    {{ dashboard.lojas.bloqueadas | formatNumber }}
                    estabelecimentos bloqueados
                  </li>
                  <li>
                    {{ dashboard.lojas.removidas | formatNumber }}
                    estabelecimentos inativos que serão removidos em breve
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- INFOS RELEVANTES -->
        <v-col class="ml-2">
          <v-card class="w-25">
            <v-card-text>
              <div>Estatísticas dos estabelecimentos</div>
              <p class="text-h4 text--primary">Estatísticas</p>
              <div class="text--primary">
                <ul>
                  <li>
                    O ticket médio dos pedidos é de
                    {{
                      dashboard.infosRelevantes.ticketMedioPedido.toLocaleString(
                        "pt-br",
                        { style: "currency", currency: "BRL" }
                      )
                    }}
                  </li>
                  <li>
                    A média das avaliações é de
                    {{ dashboard.infosRelevantes.avaliacoes.media }}
                  </li>
                  <li>
                    Cada cliente faz em média
                    {{ dashboard.infosRelevantes.recorrenciaPedidos }} pedidos
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div class="my-5 py-2">
        <h3>Relatório gerencial</h3>
        <hr />
      </div>

      <v-row>
        <v-col class="ml-2">
          <v-card class="w-25">
            <v-card-text>
              <div>Informações do mês</div>
              <p class="text-h4 text--primary">
                {{
                  new Date(0, data.getMonth(), 1).toLocaleString("default", {
                    month: "long",
                  }) | capitalize
                }}
              </p>
              <div class="text--primary">
                <ul>
                  <li>
                    NFC-e emitidas:
                    {{
                      dashboard.estatisticas.fiscal.fiscal30dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.fiscal.lojas30dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    NF-e emitidas:
                    {{
                      dashboard.estatisticas.nfes.nfes30dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.nfes.lojas30dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    DF-e recebidas:
                    {{
                      dashboard.estatisticas.dfes.dfes30dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.dfes.lojas30dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    WhatsApp Conectados:
                    {{
                      dashboard.estatisticas.gamazap.lojas30dias | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    WhatsApp Marketing:
                    {{
                      dashboard.estatisticas.gamazap_campanhas.lojas30dias
                      | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    Robôs de atendimento:
                    {{ dashboard.estatisticas.robo.lojas30dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-TEF:
                    {{ dashboard.estatisticas.gtef.lojas30dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-POS:
                    {{ dashboard.estatisticas.gpos.lojas30dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    Suporte ao cliente:
                    {{ dashboard.estatisticas.suporte.lojas30dias | formatNumber }}
                    lojas
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="ml-2">
          <v-card class="w-25">
            <v-card-text>
              <div>Informações do mês</div>
              <p class="text-h4 text--primary">
                {{
                  new Date(0, data.getMonth() - 1, 1).toLocaleString(
                    "default",
                    { month: "long" }
                  ) | capitalize
                }}
              </p>
              <div class="text--primary">
                <ul>
                  <li>
                    NFC-e emitidas:
                    {{
                      dashboard.estatisticas.fiscal.fiscal60dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.fiscal.lojas60dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    NF-e emitidas:
                    {{
                      dashboard.estatisticas.nfes.nfes60dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.nfes.lojas60dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    DF-e recebidas:
                    {{
                      dashboard.estatisticas.dfes.dfes60dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.dfes.lojas60dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    WhatsApp Conectados:
                    {{
                      dashboard.estatisticas.gamazap.lojas60dias | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    WhatsApp Marketing:
                    {{
                      dashboard.estatisticas.gamazap_campanhas.lojas60dias
                      | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    Robôs de atendimento:
                    {{ dashboard.estatisticas.robo.lojas60dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-TEF:
                    {{ dashboard.estatisticas.gtef.lojas60dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-POS:
                    {{ dashboard.estatisticas.gpos.lojas60dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    Suporte ao cliente:
                    {{ dashboard.estatisticas.suporte.lojas60dias | formatNumber }}
                    lojas
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col class="ml-2">
          <v-card class="w-25">
            <v-card-text>
              <div>Informações do mês</div>
              <p class="text-h4 text--primary">
                {{
                  new Date(0, data.getMonth() - 2, 1).toLocaleString(
                    "default",
                    { month: "long" }
                  ) | capitalize
                }}
              </p>
              <div class="text--primary">
                <ul>
                  <li>
                    NFC-e emitidas:
                    {{
                      dashboard.estatisticas.fiscal.fiscal90dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.fiscal.lojas90dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    NF-e emitidas:
                    {{
                      dashboard.estatisticas.nfes.nfes90dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.nfes.lojas90dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    DF-e recebidas:
                    {{
                      dashboard.estatisticas.dfes.dfes90dias | formatNumber
                    }}
                    emissões ({{
                      dashboard.estatisticas.dfes.lojas90dias | formatNumber
                    }}
                    lojas)
                  </li>
                  <li>
                    WhatsApp Conectados:
                    {{
                      dashboard.estatisticas.gamazap.lojas90dias | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    WhatsApp Marketing:
                    {{
                      dashboard.estatisticas.gamazap_campanhas.lojas90dias
                      | formatNumber
                    }}
                    lojas
                  </li>
                  <li>
                    Robôs de atendimento:
                    {{ dashboard.estatisticas.robo.lojas90dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-TEF:
                    {{ dashboard.estatisticas.gtef.lojas90dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    G-POS:
                    {{ dashboard.estatisticas.gpos.lojas90dias | formatNumber }}
                    lojas
                  </li>
                  <li>
                    Suporte ao cliente:
                    {{ dashboard.estatisticas.suporte.lojas90dias | formatNumber }}
                    lojas
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { fetchApiClientes } from "../../services/api";
import { verificarSessao, encerrar, getMes } from "../../utils/utils";

export default {
  name: "Dashboard",
  data() {
    return {
      data: new Date(),
      loading: false,
      error: {
        show: false,
        message: "",
      },
      modal: {},
      dashboard: {
        faturamento: {
          maior: [],
          menor: [],
        },
        vendas: {
          maior: [],
          menor: [],
        },
        criticas: [],
        lojas: {
          total: 0,
          abertas: 0,
          fechadas: 0,
          pausadas: 0,
          atrasados: 0,
          removidas: 0,
          bloqueadas: 0,
          demos: 0,
        },
        totalizadores: {
          faturamento: 0,
          pedidos: 0,
          usuarios: 0,
          visitas: 0,
        },
        infosRelevantes: {
          recorrenciaPedidos: 0,
          ticketMedioPedido: 0,
          avaliacoes: {
            qtd: 0,
            media: 0,
          },
        },
        estatisticas: {
          fiscal: {
            lojas30dias: 0,
            fiscal30dias: 0,
            lojas60dias: 0,
            fiscal60dias: 0,
            lojas90dias: 0,
            fiscal90dias: 0,
          },
          nfes: {
            lojas30dias: 0,
            nfes30dias: 0,
            lojas60dias: 0,
            nfes60dias: 0,
            lojas90dias: 0,
            nfes90dias: 0,
          },
          dfes: {
            lojas30dias: 0,
            dfes30dias: 0,
            lojas60dias: 0,
            dfes60dias: 0,
            lojas90dias: 0,
            dfes90dias: 0,
          },
          gamazap: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
          gamazap_campanhas: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
          robo: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
          gtef: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
          gpos: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
          suporte: {
            lojas30dias: 0,
            lojas60dias: 0,
            lojas90dias: 0,
          },
        },
      },
      token: localStorage.getItem("token"),
      responsavel: {},
    };
  },
  async created() {
    window.addEventListener("offline", () => (this.loading = true));
    window.addEventListener("online", () => (this.loading = false));
    /**
     *
     */
    verificarSessao(this.atualizar);
    setTimeout(verificarSessao, 1 * 60000);
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
      // Emitir evento global para cobrir o sidebar também
      this.$root.$emit('global-loading', loading);
    },
    setError(error, title) {
      console.error(title, error);
      /**
       *
       */
      this.error = {
        show: true,
        title: title ? title : "Ops, falhou!",
        message: error ? error : "Falha não identificada, tente novamente.",
      };
    },
    /**
     *
     */
    atualizar() {
      this.setLoading(true);
      fetchApiClientes(this.token)
        .then((response) => {
          this.setLoading(false);
          return this.montar(response.data);
        })
        .catch((error) => {
          this.setLoading(false);
          switch (error?.response?.status) {
            case 401:
              return this.sair();
            default:
              this.setError(error?.response?.data?.message);
              break;
          }
        });
    },
    montar(data) {
      try {
        this.dashboard = {
          data: new Date(),
          faturamento: {
            maior: [],
            menor: [],
          },
          vendas: {
            maior: [],
            menor: [],
          },
          criticas: [],
          lojas: {
            total: 0,
            abertas: 0,
            fechadas: 0,
            pausadas: 0,
            atrasados: 0,
            removidas: data?.clientes?.filter(loja => loja.ativo === false).length,
            bloqueadas: 0,
            demos: 0,
          },
          totalizadores: {
            faturamento: 0,
            pedidos: 0,
            usuarios: 0,
            visitas: 0,
          },
          infosRelevantes: {
            recorrenciaPedidos: 0,
            ticketMedioPedido: 0,
            avaliacoes: {
              qtd: 0,
              media: 0,
            },
          },
          estatisticas: {
            fiscal: {
              lojas30dias: 0,
              fiscal30dias: 0,
              lojas60dias: 0,
              fiscal60dias: 0,
              lojas90dias: 0,
              fiscal90dias: 0,
            },
            nfes: {
              lojas30dias: 0,
              nfes30dias: 0,
              lojas60dias: 0,
              nfes60dias: 0,
              lojas90dias: 0,
              nfes90dias: 0,
            },
            dfes: {
              lojas30dias: 0,
              dfes30dias: 0,
              lojas60dias: 0,
              dfes60dias: 0,
              lojas90dias: 0,
              dfes90dias: 0,
            },
            gamazap: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
            gamazap_campanhas: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
            robo: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
            gtef: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
            gpos: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
            suporte: {
              lojas30dias: 0,
              lojas60dias: 0,
              lojas90dias: 0,
            },
          },
        };
        /**
         *
         */
        if (data?.responsavel) {
          this.responsavel = data?.responsavel;
        }
        /**
         *
         */
        let haveAnalytics = data?.clientes?.filter((loja) => {
          this.dashboard.lojas.total++;
          switch (loja.status) {
            case "🟢":
              this.dashboard.lojas.abertas++;
              break;
            case "🔴":
            case "🟠":
              this.dashboard.lojas.fechadas++;
              break;
          }
          /**
           *
           */
          if (loja.situacao != "🟢") {
            this.dashboard.lojas.atrasados++;
          }
          if (loja.block === "🔴") {
            this.dashboard.lojas.bloqueadas++;
          }
          if (/demo/gi.test(loja.responsavel)) {
            this.dashboard.lojas.demos++;
          }
          /**
           *
           */
          if (loja.manutencao == "🔴") {
            this.dashboard.criticas.push({
              critica: `${loja.nome} está com o sistema em manutenção.`,
            });
          }
          if (loja.logs == "🟢") {
            this.dashboard.criticas.push({
              critica: `${loja.nome} está com o log ativo.`,
            });
          }
          if (loja.cache == "🔴") {
            this.dashboard.criticas.push({
              critica: `${loja.nome} está com o cache desativado.`,
            });
          }
          /**
           *
           */
          if (loja.analytics) {
            this.dashboard.totalizadores.faturamento += parseFloat(
              loja.analytics?.fat30dias ?? 0
            );
            this.dashboard.totalizadores.pedidos += parseFloat(
              loja.analytics?.totalPedidos ?? 0
            );
            this.dashboard.totalizadores.usuarios += parseFloat(
              loja.analytics?.totalUsuarios ?? 0
            );
            this.dashboard.totalizadores.visitas += parseFloat(
              loja.analytics?.visitas30dias ?? 0
            );
            /**
             *
             */
            let rejeicoes = parseInt(
              loja.analytics?.fiscalRejeitadas30dias ?? 0
            );
            if (rejeicoes > 0) {
              this.dashboard.criticas.push({
                critica: `${loja.nome} está com ${rejeicoes} NFC-es rejeitadas que precisam de atenção.`,
              });
            }
            this.dashboard.estatisticas.fiscal.fiscal30dias += parseInt(
              loja.analytics?.fiscal30dias ?? 0
            );
            if (loja.analytics?.fiscal30dias > 0) {
              this.dashboard.estatisticas.fiscal.lojas30dias += 1;
            }
            this.dashboard.estatisticas.fiscal.fiscal60dias += parseInt(
              loja.analytics?.fiscal60dias ?? 0
            );
            if (loja.analytics?.fiscal60dias > 0) {
              this.dashboard.estatisticas.fiscal.lojas60dias += 1;
            }
            this.dashboard.estatisticas.fiscal.fiscal90dias += parseInt(
              loja.analytics?.fiscal90dias ?? 0
            );
            if (loja.analytics?.fiscal90dias > 0) {
              this.dashboard.estatisticas.fiscal.lojas90dias += 1;
            }
            /**
             *
             */
            this.dashboard.estatisticas.nfes.nfes30dias += parseInt(
              loja.analytics?.nfes30dias ?? 0
            );
            if (loja.analytics?.nfes30dias > 0) {
              this.dashboard.estatisticas.nfes.lojas30dias += 1;
            }
            this.dashboard.estatisticas.nfes.nfes60dias += parseInt(
              loja.analytics?.nfes60dias ?? 0
            );
            if (loja.analytics?.nfes60dias > 0) {
              this.dashboard.estatisticas.nfes.lojas60dias += 1;
            }
            this.dashboard.estatisticas.nfes.nfes90dias += parseInt(
              loja.analytics?.nfes90dias ?? 0
            );
            if (loja.analytics?.nfes90dias > 0) {
              this.dashboard.estatisticas.nfes.lojas90dias += 1;
            }
            /**
             *
             */
            this.dashboard.estatisticas.dfes.dfes30dias += parseInt(
              loja.analytics?.dfes30dias ?? 0
            );
            if (loja.analytics?.dfes30dias > 0) {
              this.dashboard.estatisticas.dfes.lojas30dias += 1;
            }
            this.dashboard.estatisticas.dfes.dfes60dias += parseInt(
              loja.analytics?.dfes60dias ?? 0
            );
            if (loja.analytics?.dfes60dias > 0) {
              this.dashboard.estatisticas.dfes.lojas60dias += 1;
            }
            this.dashboard.estatisticas.dfes.dfes90dias += parseInt(
              loja.analytics?.dfes90dias ?? 0
            );
            if (loja.analytics?.nfes90dias > 0) {
              this.dashboard.estatisticas.nfes.lojas90dias += 1;
            }
            /**
             *
             */
            if (loja.analytics[`modulos_mes${getMes()}`]) {
              this.dashboard.estatisticas.gamazap.lojas30dias += parseInt(
                loja.analytics[`modulos_mes${getMes()}`].gamazap ?? 0
              );

              this.dashboard.estatisticas.gamazap_campanhas.lojas30dias +=
                parseInt(
                  loja.analytics[`modulos_mes${getMes()}`].gamazap_campanhas ??
                  0
                );

              this.dashboard.estatisticas.robo.lojas30dias += parseInt(
                loja.analytics[`modulos_mes${getMes()}`].robo ?? 0
              );

              this.dashboard.estatisticas.gtef.lojas30dias += parseInt(
                loja.analytics[`modulos_mes${getMes()}`].gtef ?? 0
              );

              this.dashboard.estatisticas.gpos.lojas30dias += parseInt(
                loja.analytics[`modulos_mes${getMes()}`].gpos ?? 0
              );

              this.dashboard.estatisticas.suporte.lojas30dias += parseInt(
                loja.analytics[`modulos_mes${getMes()}`].suporte_dedicado ?? 0
              );
            }
            if (loja.analytics[`modulos_mes${getMes(-1)}`]) {
              this.dashboard.estatisticas.gamazap.lojas60dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-1)}`].gamazap ?? 0
              );

              this.dashboard.estatisticas.gamazap_campanhas.lojas60dias +=
                parseInt(
                  loja.analytics[`modulos_mes${getMes(-1)}`]
                    .gamazap_campanhas ?? 0
                );

              this.dashboard.estatisticas.robo.lojas60dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-1)}`].robo ?? 0
              );

              this.dashboard.estatisticas.gtef.lojas60dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-1)}`].gtef ?? 0
              );

              this.dashboard.estatisticas.gpos.lojas60dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-1)}`].gpos ?? 0
              );

              this.dashboard.estatisticas.suporte.lojas60dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-1)}`].suporte_dedicado ?? 0
              );
            }

            if (loja.analytics[`modulos_mes${getMes(-2)}`]) {
              this.dashboard.estatisticas.gamazap.lojas90dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-2)}`].gamazap ?? 0
              );

              this.dashboard.estatisticas.gamazap_campanhas.lojas90dias +=
                parseInt(
                  loja.analytics[`modulos_mes${getMes(-2)}`]
                    .gamazap_campanhas ?? 0
                );

              this.dashboard.estatisticas.robo.lojas90dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-2)}`].robo ?? 0
              );

              this.dashboard.estatisticas.gtef.lojas90dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-2)}`].gtef ?? 0
              );

              this.dashboard.estatisticas.gpos.lojas90dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-2)}`].gpos ?? 0
              );

              this.dashboard.estatisticas.suporte.lojas90dias += parseInt(
                loja.analytics[`modulos_mes${getMes(-2)}`].suporte_dedicado ?? 0
              );
            }
            /***
             *
             */
            this.dashboard.infosRelevantes.avaliacoes.qtd++;
            this.dashboard.infosRelevantes.avaliacoes.media += parseFloat(
              loja.analytics.mediaAvaliacao ?? 0
            );
          }
          /**
           *
           */
          return loja?.analytics?.fat30dias >= 0 ? true : false;
        });
        /**
         *
         */
        let topFaturamentos = [...haveAnalytics].sort(function (a, b) {
          return parseFloat(a.analytics.fat30dias) >
            parseFloat(b.analytics.fat30dias)
            ? -1
            : 1;
        });
        let piorFaturamento = [...haveAnalytics].sort(function (a, b) {
          return a.analytics &&
            parseFloat(a.analytics.fat30dias) >
            parseFloat(b.analytics.fat30dias)
            ? 1
            : -1;
        });
        this.dashboard.faturamento = {
          maior: topFaturamentos.slice(0, 20),
          menor: piorFaturamento.slice(0, 20),
        };
        /**
         *
         */
        let topVendas = [...haveAnalytics].sort(function (a, b) {
          return parseFloat(a.analytics.totalPedidos) >
            parseFloat(b.analytics.totalPedidos)
            ? -1
            : 1;
        });
        let piorVendas = [...haveAnalytics].sort(function (a, b) {
          return parseFloat(a.analytics.totalPedidos) >
            parseFloat(b.analytics.totalPedidos)
            ? 1
            : -1;
        });
        this.dashboard.vendas = {
          maior: topVendas.slice(0, 20),
          menor: piorVendas.slice(0, 20),
        };
        /**
         *
         */
        this.dashboard.infosRelevantes.ticketMedioPedido = parseFloat(
          this.dashboard.totalizadores.faturamento /
          this.dashboard.totalizadores.pedidos
        );
        this.dashboard.infosRelevantes.avaliacoes.media = parseFloat(
          this.dashboard.infosRelevantes.avaliacoes.media /
          this.dashboard.infosRelevantes.avaliacoes.qtd
        ).toFixed(2);
        this.dashboard.infosRelevantes.recorrenciaPedidos = parseFloat(
          this.dashboard.totalizadores.pedidos /
          this.dashboard.totalizadores.usuarios
        ).toFixed(2);
        this.dashboard.infosRelevantes.emissoesFiscais30dias =
          this.dashboard.totalizadores.emissoesFiscais;
      } catch (error) {
        console.error(error);
        this.setError(error?.message);
      }
    },
    sair() {
      return encerrar();
    },
  },
};
</script>

<style>
body {
  margin: 15px !important;
}
</style>
